import { evaluateRoleInput } from './rolePredicates';
/**
 * Utility function to match roles against user's identity roles
 * @param roles - Roles that should match (optional)
 * @param identityRoles - User's identity roles array
 * @returns boolean indicating if the role conditions are met
 */
export const matchRoles = (roles, identityRoles) => roles === undefined || evaluateRoleInput(roles, identityRoles);
